import RadioCardListPage from "@components/RadioCardListPage"

const OPTIONS = [
  { emoji: "🚀", key: "yes" },
  { emoji: "👀", key: "showMe" },
  { emoji: "💪", key: "almost" },
]

export default function HairstyleReadyToTransformPage() {
  return (
    <RadioCardListPage
      translationKey="readyToTransformHairstyle"
      options={OPTIONS}
      subtitle="subtitle"
    />
  )
}
